export default {
  'memberAreaJourney.title': 'Member Journey',
  'memberAreaJourney.period': 'Validity Period',
  'memberAreaJourney.no_records': 'No member journey records yet',
  'memberAreaJourney.reason_1': 'New Member',
  'memberAreaJourney.reason_2': 'Upgrade by Spending',
  'memberAreaJourney.reason_3': 'Manual Upgrade',
  'memberAreaJourney.reason_4': 'Manual Downgrade',
  'memberAreaJourney.reason_5': 'Downgraded due to Expiration',
  'memberAreaJourney.reason_6': 'Renewed with Same Level',
  'memberAreaJourney.reason_7': 'Downgraded due to Cancelled Transaction',
  'memberAreaJourney.reason_8': 'Specified Downgrade upon Expiration',
  'memberAreaJourney.reason_9': 'Specified Renewal upon Expiration',
  'memberAreaJourney.reason_10': 'New Membership System Launched',
} as Record<string, string>;
